var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-1"},[_c('ListCorrespondences',{attrs:{"nodeId":_vm.nodeId,"forUserOnly":_vm.forUserOnly,"forStructureOnly":_vm.forStructureOnly}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }